/*
 * Copyright (c) 2017-2026 Brighter AI Technologies GmbH. All rights reserved.
 * Unauthorized use, copying, reproduction, or distribution of this file, via any medium,
 * is strictly prohibited.
 */

import {
  Dialog,
  DialogActions,
  DialogContent,
  Button,
  DialogTitle,
  makeStyles,
  DialogContentText,
} from "@material-ui/core";

export const ActionTypes = {
  ACCEPTED: 0,
  DECLINED: 1,
  SKIPPED: 2,
};

const useStyles = makeStyles((theme) => ({
  dialog: {
    borderRadius: 0,
    width: 530,
    paddingRight: theme.spacing(5),
    paddingBottom: theme.spacing(5),
  },
  button: {
    width: 190,
  },
  title: {
    "& h2": {
      color: theme.palette.primary.contrastText,
      fontSize: theme.typography.h3.fontSize,
    },
  },
  text: {
    color: theme.palette.primary.contrastText,
    fontSize: theme.typography.h4.fontSize,
  },
}));

export function CustomNotification({
  open = false,
  headerText = "",
  bodyText = "",
  onAction,
  acceptButtonText,
  declineButtonText,
}) {
  const classes = useStyles();

  function getButton(type, variant, text) {
    if (!text) return null;
    return (
      <Button onClick={() => handleAction(type)} variant={variant}>
        {text}
      </Button>
    );
  }

  function handleAction(actionTypes) {
    onAction(actionTypes);
  }

  return (
    <Dialog
      open={open}
      keepMounted
      classes={{ paper: classes.dialog }}
      data-testid="custom-notification"
    >
      <DialogTitle className={classes.title}>{headerText}</DialogTitle>
      <DialogContent>
        <DialogContentText className={classes.text}>
          {bodyText}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {getButton(ActionTypes.DECLINED, "outlined", declineButtonText)}
        {getButton(ActionTypes.ACCEPTED, "contained", acceptButtonText)}
      </DialogActions>
    </Dialog>
  );
}
